import { API_URL } from "lib/constants";
import { sendGetHttpRequest } from "lib/fetcher";

export function getCamerasForAdmin(
  id: number,
  macAddress: string,
  nvrSn: string,
  limit: number,
  offset: number,
  siteName?: string,
) {
  return sendGetHttpRequest(
    `${API_URL}/camera/cameras/admin?id=${id}&macAddress=${macAddress}&nvrSn=${nvrSn}&page.limit=${limit}&page.offset=${offset}&siteName=${siteName}`,
  );
}
